import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* getById({ payload: { auditId } }) {
  try {
    const { data } = yield call(dataProvider.getOne, 'audit', { id: auditId });
    const audit = (data && data.data) || data || null;
    yield put({ type: psmAuditDigital.getById.end, payload: audit });
  } catch (e) {
    yield put({ type: psmAuditDigital.getById.error });
    yield put({ type: notification.add, payload: { error: getNotificationErrorMessage(e, 'Failed to load audit') } });
  }
}

export default function* getByIdSaga() {
  yield takeLatest(psmAuditDigital.getById.start, getById);
}
